import PropTypes from 'prop-types';
import React from 'react';

import { ToastContainer } from 'react-toastify';
import SocialPostsList from '../../ScheduledPosts/components/SocialPostsList';

const PostedPosts = ({
  csrfToken,
  team,
  currentUser,
  dataTableDataSource,
  reloadKey,
  deletePost,
  authorizedPages,
  hasPosts
}) => (
  <div>
    <ToastContainer icon={false} />
    <SocialPostsList
      view="posted"
      dataSource={dataTableDataSource}
      team={team}
      currentUser={currentUser}
      authorizedPages={authorizedPages}
      hasPosts={hasPosts}
      reloadKey={reloadKey}
      onRemovePost={(post) => deletePost(csrfToken, team, post)}
    />
  </div>
);

PostedPosts.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  reloadKey: PropTypes.number,
  deletePost: PropTypes.func.isRequired,
  authorizedPages: PropTypes.array,
  hasPosts: PropTypes.bool
};

export default PostedPosts;
